import { ReportDefinition } from "./models/tipoReporte.mode";

export const REPORTES: ReportDefinition[] = [
  {
    tipo: 'bienes-culturales',
    nombre: 'Bienes Culturales',
    endpoint: '/api/reportes/bienes-culturales',
    fields: [
      { name: 'coleccion', label: 'Colección', type: 'select', options: [] },
      { name: 'departamento', label: 'Departamento', type: 'select', options: [] },
      { name: 'municipio', label: 'Municipio', type: 'select', options: [] }
    ]
  },
  {
    tipo: 'solicitudes',
    nombre: 'Solicitudes',
    endpoint: '/api/reportes/solicitudes',
    fields: [
      { name: 'estado', label: 'Estado', type: 'select', options: [] },
      { name: 'TipoDocumento', label: 'Tipo de Documento', type: 'select', options: [] },
      { name: 'usuario', label: 'Usuario', type: 'select', options: [] }
    ]
  },
  {
    tipo: 'gestiones',
    nombre: 'Gestiones',
    endpoint: '/api/reportes/gestiones',
    fields: [
      { name: 'estado', label: 'Estado', type: 'select', options: [] },
      { name: 'origen', label: 'Origen de la gestión', type: 'select', options: [] },
      { name: 'usuario', label: 'Usuario', type: 'select', options: [] }
    ]
  },
  {
    tipo: 'documentos-oficiales',
    nombre: 'Documentos Oficiales',
    endpoint: '/api/reportes/documento-generado',
    fields: [
      { name: 'estado', label: 'Estado del documento', type: 'select', options: [] },
      { name: 'TipoDocumento', label: 'Nombre del documento', type:'select', options: [] },
      { name: 'usuario', label: 'Creado Por', type: 'select', options: [] }
    ]
  }
];

